class ValidationError extends Error {
  constructor(errors, message = "A validation error occurred") {
    super(message);
    this.name = this.constructor.name;
    this.errors = errors;

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }

  getErrors() {
    return this.errors;
  }
}

export const handleSuccess = (response) => response.data;

export const handleError = (errorResponse) => {
  if (!errorResponse.response) {
    return Promise.reject(new Error("Server Didn't Respond"));
  }
  const { status } = errorResponse.response;
  /*
    fetch error message from a typical response API such as ....
  */
  let { errors, message } = errorResponse.response.data;
  const { error } = errorResponse.response.data;

  /*
    if there is a string labeled "message" in the response, assume this is the message to show the user,
    otherwise, look for messages in the error objects...
  */
  if (message === undefined || typeof message !== "string") {
    // sometimes (e.g. PayDock, errors is named 'error')...
    errors = errors === undefined && error !== undefined ? error : errors;

    if (Object.prototype.toString.call(errors) === "[object Array]") {
      message = errors.join(" ");
    } else if (errors && status !== 422) {
      // sometimes error is an object
      message = "";
      Object.keys(errors).forEach((key) => {
        if (typeof errors[key] === "string") {
          message += `${errors[key]} `;
        }
      });
    }
  }

  switch (status) {
    case 422:
      return Promise.reject(new ValidationError(errors, message));
    case 404:
      return Promise.reject(new Error("Not Found"));
    case 403:
      return Promise.reject(new Error(message));
    case 401:
      if (message) {
        return Promise.reject(new Error(message));
      }
      return Promise.reject(new Error("Unauthenticated"));
    default:
      return Promise.reject(
        new Error(
          message || "An unexpected error has occurred. Please try again."
        )
      );
  }
};
